module.exports = __webpack_public_path__ + "img/mobile-p-w.0eaeb9c2.png";